/**
 * FilterBuilder field lists for the contract lists. Enum fields use
 * `input:'select'` so a condition folds into the backend base64 `filters`
 * object (`{ contract_status: [...] }`), matching the customer-list pattern.
 *
 * Date-range filters (effective/expiry/created) the legacy page offered are
 * deferred: the backend expects paired `<field>` + `<field>_to` params, which
 * the base64 `{ field: [...] }` filter model doesn't express — wiring that needs
 * a live probe of the range param shape. Search (`q`) covers text lookup today.
 */
import type { FilterField } from '@vnetwork/ui/data';
import {
  CONTRACT_STATUS_OPTIONS,
  CONTRACT_ROLE_OPTIONS,
  CONTRACT_DIRECTION_OPTIONS,
} from '../contract-format';

const statusFilter: FilterField = {
  value: 'contract_status',
  label: 'Status',
  input: 'select',
  options: CONTRACT_STATUS_OPTIONS,
};

const roleFilter: FilterField = {
  value: 'contract_role',
  label: 'Role',
  input: 'select',
  options: CONTRACT_ROLE_OPTIONS,
};

const directionFilter: FilterField = {
  value: 'contract_direction',
  label: 'Direction',
  input: 'select',
  options: CONTRACT_DIRECTION_OPTIONS,
};

/** Customer (sell-side) contract filters: status · role · direction. */
export const customerContractFilters: FilterField[] = [statusFilter, roleFilter, directionFilter];

/** Partner (buy-side) contract filters: status only (no role/direction on DTO). */
export const partnerContractFilters: FilterField[] = [statusFilter];
